export enum EventKey {
	Escape = "Escape",
	Enter = "Enter",
	Tab = "Tab",
	Space = " ",
	ArrowDown = "ArrowDown",
	ArrowLeft = "ArrowLeft",
	ArrowRight = "ArrowRight",
	ArrowUp = "ArrowUp",
	End = "End",
	Home = "Home",
	PageDown = "PageDown",
	PageUp = "PageUp",
}
